export const SELECT_SCHOOLBOOK = 'UMK_MODAL.SELECT_SCHOOLBOOK';
export const FILTER_SCHOOLBOOKS = 'UMK_MODAL.FILTER_SCHOOLBOOKS';
